module.exports = __webpack_public_path__ + "fonts/Lato-100-2.6219d77.woff2";